import { render, staticRenderFns } from "./custom-image.vue?vue&type=template&id=0f957080"
import script from "./custom-image.vue?vue&type=script&lang=js"
export * from "./custom-image.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports